import { get } from "lodash";
import styled from "styled-components";
import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { CgAsterisk } from "react-icons/cg";
import { Avatar, Grid, Typography } from "@mui/material";

import { uploadToS3 } from "../../../utils";
import { colors } from "../../css components/Style";
import SubNavbar from "../../../components/SubNavbar";
import { ErrorButton } from "../../css components/Button";
import EditButtons from "../../../components/EditButtons";
import SubmitButtons from "../../../components/SubmitButtons";
import { AutocompleteMultiSelect, TextField } from "../../../components";

const ImageAvatar = styled(Avatar)`
  height: 130px;
  width: 130px;
  padding: 10px;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
`;

const AllowedImage = styled(Typography)`
  color: #333;
  font-size: 15px;
  opacity: 0.8;
  margin-top: 15px;
`;

export default function FormOne({
  setEditState,
  list,
  formikProps,
  editState,
}) {
  const agencyID =
    useSelector((state) => state.memberDetails.agencyID) ||
    sessionStorage.getItem("agencyID");

  return (
    <React.Fragment>
      <Grid size={12}>
        <SubNavbar
          buttons={[
            editState ? (
              <SubmitButtons
                ID={formikProps.values.brandID}
                editState={editState}
                setEditState={setEditState}
                formikProps={formikProps}
              />
            ) : (
              <EditButtons editState={editState} setEditState={setEditState} />
            ),
          ]}
          pageName={"Brand Details"}
        />
      </Grid>

      <Grid item textAlign="center" display="flex">
        <ImageAvatar src={formikProps.values.brandAvatar} />
      </Grid>

      {editState && (
        <Grid item alignSelf={"center"}>
          <div style={{ display: "flex" }}>
            <input
              disabled={!editState}
              accept=".jpg,.jpeg,.png"
              style={{ display: "none" }}
              id="avatar-button-file"
              multiple
              onChange={(event) => handleFileChange(event, "brandAvatar")}
              type="file"
            />
            <label htmlFor="avatar-button-file">
              <div
                className="add-new-logo"
                variant="contained"
                style={{
                  marginRight: "10px",
                  backgroundColor: colors.sprintexBlue,
                }}
              >
                Add New Logo
              </div>
            </label>

            {formikProps.values.brandAvatar && (
              <ErrorButton
                variant="outlined"
                onClick={() => {
                  formikProps.setValues((prev) => ({
                    ...prev,
                    brandAvatar: "",
                  }));
                }}
              >
                Reset
              </ErrorButton>
            )}
          </div>

          <AllowedImage>
            Allowed JPG, GIF or PNG
            {!formikProps.values.brandAvatar && !agencyID && (
              <CgAsterisk style={{ color: colors.error }} />
            )}
            .
          </AllowedImage>
        </Grid>
      )}

      <Grid size={12} />

      <Grid size={6}>
        <TextField
          label="Brand Name"
          disabled={!editState}
          formikProps={formikProps}
          placeholder="Brand Name"
          name="brandName"
          required
          inputProps={{ maxLength: 35 }}
        />
      </Grid>

      <Grid size={6}>
        <TextField
          label="Website"
          disabled={!editState}
          formikProps={formikProps}
          name="website"
          placeholder="Website"
          inputProps={{ "aria-label": "Without label" }}
        />
      </Grid>

      {!agencyID && (
        <Grid size={6}>
          <TextField
            label="Online Store"
            disabled={!editState}
            formikProps={formikProps}
            name="onlineStore"
            placeholder="Online Store"
          />
        </Grid>
      )}

      {agencyID && (
        <Fragment>
          <Grid size={6}>
            <AutocompleteMultiSelect
              required={agencyID ? false : true}
              name="siteCategory"
              label={"Business Category"}
              disabled={!editState}
              forcePopupIcon={!editState ? false : true}
              formikProps={formikProps}
              defaults={{
                primaryKey: "name",
                displayLabel: "name",
              }}
              options={list?.categories}
              placeholder="Select Category"
              onChange={(_, arr, reason, option) => {
                handleChange(arr, option, reason, "siteCategory", "name");
              }}
            />
          </Grid>

          {formikProps.values.siteCategory.includes("Others") && (
            <Fragment>
              <Grid size={6}>
                <TextField
                  required
                  disabled={!editState}
                  formikProps={formikProps}
                  name="others_category"
                  label={"Enter your other category"}
                  placeholder={"Enter your other category"}
                />
              </Grid>
            </Fragment>
          )}
        </Fragment>
      )}

      {!agencyID && (
        <Grid size={6}>
          <TextField
            label="Monthly Active Users"
            disabled={!editState}
            formikProps={formikProps}
            name="monthlyActiveUsers"
            placeholder="Monthly Active Users"
            inputProps={{ type: "number" }}
          />
        </Grid>
      )}
    </React.Fragment>
  );

  function handleChange(arr, { option }, reason, name, displayName) {
    formikProps.setValues((prevVal) => ({
      ...prevVal,
      [name]: setValuesOfDropDown(prevVal[name]),
    }));

    function setValuesOfDropDown(val) {
      let values = [...val];

      if (reason === "removeOption") {
        const nameToDropDown = {
          audienceLocation: "country_code",
          siteCategory: "name",
          audienceLanguages: "code",
        };

        let dropDownName = nameToDropDown[name];

        if (option[dropDownName]) {
          values = [
            ...values.filter((items) => items !== option[dropDownName]),
          ];
        } else {
          values.pop();
        }
      }
      if (reason === "selectOption") {
        values.push(option[displayName]);
      }

      return values;
    }
  }

  function handleFileChange({ target }, name) {
    let folderPath = "company_document/" + new Date().getTime() + "_";
    const file = get(target, "files[0]", "");
    let fileName = file?.name?.replace(/[&\/\\#,+()$~%'":*?<>{}]/g, "");
    const uploadBucket = {
      name: "adn-media",
      region: "ap-south-1",
      identityPoolID: "ap-south-1:e58786e7-9711-4dea-a2e2-7d9c10e38333",
    };

    uploadToS3({
      bucket: uploadBucket,
      filePath: folderPath + fileName,
      file,
    }).then((response) => {
      if (response.status) {
        formikProps.setFieldValue(
          [name],
          "https://" +
            uploadBucket.name +
            ".s3.ap-south-1.amazonaws.com/" +
            folderPath +
            fileName
        );
      }
    });
  }
}
